import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { useLogout } from '../../hooks/useLogout';

export const OpenApiGuestWarning = () => {
  const logout = useLogout();

  return (
    <Alert severity="warning">
      <Typography component="span" fontWeight={500}>
        Warning!
      </Typography>{' '}
      You must be logged in to try this API.{' '}
      <Link
        component="button"
        sx={{ verticalAlign: 'baseline' }}
        onClick={logout}
      >
        Log in
      </Link>{' '}
      or{' '}
      <Link component={RouterLink} to="/signup">
        Create an account.
      </Link>
    </Alert>
  );
};
